import { default as Container } from './GroupGallectionPopover.container';
import { default as Component } from './GroupGallectionPopover';
export default Container(Component);
